<template>
  <div class="main-content-container container-fluid px-4">
    <div class="email-logo">
      <a href="https://www.spring.app" class="nav-logo mobile-align" to="/">
        <img class="logo-size" src="@/assets/images/spring-logo.svg" alt="spring logo" />
      </a>
      <div class="subtext mb-3">Put your outbound marketing on autopilot</div>
    </div>

    <div class="row">
      <div class="main-content col p-0">
        <div class="main-content-container container-fluid my-auto h-100 m-0 px-2 pb-5">
          <div class="row">
            <div class="col-lg-8 mx-auto mt-4">
              <div class="page-header row no-gutters py-4">
                <div class="col-12 col-sm-6 text-center text-sm-left mb-0 mt-4 mb-sm-0">
                  <span class="text-uppercase page-subtitle">Manage Settings</span>
                  <h5 class="page-title">Email Updates</h5>
                </div>
              </div>
              <div class="card card-small edit-user-details mb-4">
                <div class="card-header p-0"></div>
                <div class="card-body p-0">
                  <form action="#" class="py-4">
                    <div class="form-row mx-4">
                      <div class="col">
                        <h6 class="font-weight-bold form-text m-0">Notifications</h6>
                        <p
                          class="form-text text-muted m-0"
                        >Choose which email notifications you receive and how often</p>
                      </div>
                    </div>
                    <div class="form-row mx-4 mt-4">
                      <label for="SpringUpdatesEmailsToggle" class="col col-form-label">
                        Spring Updates
                        <p
                          class="form-text mb-0 text-muted"
                        >Get emails about new features and tips & tricks</p>
                      </label>
                      <div class="col d-flex">
                        <div class="custom-control custom-toggle ml-auto my-auto">
                          <input
                            type="checkbox"
                            id="SpringUpdatesEmailsToggle"
                            class="custom-control-input"
                            defaultChecked
                          />
                          <label class="custom-control-label" for="SpringUpdatesEmailsToggle" />
                        </div>
                      </div>
                    </div>
                    <div class="form-row mx-4 mt-2">
                      <label for="MetricsEmailsToggle" class="col col-form-label">
                        Outreach Analytics Updates
                        <p
                          class="form-text mb-0 text-muted"
                        >Get a summary of your mails' performance</p>
                      </label>
                    </div>
                    <div class="form-row mx-4 py-4">
                      <div class="custom-control d-inline custom-radio pr-3">
                        <input
                          type="radio"
                          id="notificationFreq1"
                          name="notificationFreq"
                          class="custom-control-input"
                        />
                        <label class="radio-fix custom-control-label" for="notificationFreq1">Never</label>
                      </div>
                      <div class="custom-control d-inline custom-radio mb-1 pr-3">
                        <input
                          type="radio"
                          id="notificationFreq2"
                          name="notificationFreq"
                          class="custom-control-input"
                          defaultChecked
                        />
                        <label class="radio-fix custom-control-label" for="notificationFreq2">Daily</label>
                      </div>
                      <div class="custom-control d-inline custom-radio mb-1 pr-3">
                        <input
                          type="radio"
                          id="notificationFreq3"
                          name="notificationFreq"
                          class="custom-control-input"
                        />
                        <label class="radio-fix custom-control-label" for="notificationFreq3">Weekly</label>
                      </div>
                      <div class="custom-control d-inline custom-radio mb-1 pr-3">
                        <input
                          type="radio"
                          id="notificationFreq4"
                          name="notificationFreq"
                          class="custom-control-input"
                        />
                        <label
                          class="radio-fix custom-control-label"
                          for="notificationFreq4"
                        >Monthly</label>
                      </div>
                    </div>
                    <div class="card-footer border-top mb-2 mt-4">
                      <d-btn
                        @click.native="handleUnsub"
                        class="btn btn-sm btn-danger d-table ml-2 float-left font-weight-bold text-white"
                      >Unsubscribe</d-btn>
                      <d-btn
                        @click.native="handleSave"
                        class="btn btn-sm btn-primary d-table mr-2 float-right font-weight-bold text-white"
                      >Save Changes</d-btn>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Unsub Modal -->
    <d-modal v-if="showUnsub" @close="handleClose">
      <d-modal-header>
        <d-modal-title>😢Sorry to see you go</d-modal-title>
      </d-modal-header>
      <d-modal-body>You've been unsubscribed from Spring.app's mailing list. We're sorry to see you go.</d-modal-body>
    </d-modal>
    <!-- Save Settings Modal -->
    <d-modal v-if="showSave" @close="handleClose">
      <d-modal-header>
        <d-modal-title>Settings Saved</d-modal-title>
      </d-modal-header>
      <d-modal-body>👍Your changes to email update settings have been saved</d-modal-body>
    </d-modal>
  </div>

  <!-- Meta Details -->
</template>



<script>
export default {
  data() {
    return {
      showUnsub: false,
      showSave: false
    };
  },
  methods: {
    handleUnsub() {
      this.showUnsub = true;
    },
    handleSave() {
      this.showSave = true;
    },
    handleClose() {
      this.showSave = false;
      this.showUnsub = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.email-logo {
  margin: 20px auto 0px;
  text-align: center;
}

.logo-size {
  width: 120px;
}

.subtext {
  font-weight: normal;
  font-size: 15px;
}
</style>